import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type FormSwitchControllerProps = {
  controllerName: string;
  label: string;
  switchOnChange?: () => void;
};

export const FormSwitchController = ({
  controllerName,
  label,
  switchOnChange,
}: FormSwitchControllerProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Switch
              {...field}
              checked={field.value}
              onChange={(e) => {
                field.onChange(e.target.checked);
                switchOnChange?.();
              }}
            />
          }
          label={label}
          componentsProps={{
            typography: {
              fontSize: '13px',
              fontWeight: 400,
            },
          }}
        />
      )}
    />
  );
};
